export default __webpack_public_path__ + "static/media/devsigner-logo.e62f334e.svg";